import { lightTheme } from '../../../styles/theme';
import { ConversationMessageWithStatus } from '../../../types/conversation.types';
import { ChatViewer, OpenUser, senderLabel } from '../helpers/chatMessage';
import { MessageMeta, SenderName } from './MessageBubble.styled';

/**
 * The line under a bubble: normally the sender's name, once per run - or, when
 * the send failed, the way to try again in its place.
 */
export const MessageFooter = ({
  message,
  viewer,
  own,
  fallbackSenderName,
  endsRun,
  onRetry,
  onOpenUser,
}: {
  message: ConversationMessageWithStatus;
  viewer: ChatViewer;
  own: boolean;
  fallbackSenderName?: string | null;
  endsRun: boolean;
  onRetry?: (message: ConversationMessageWithStatus) => void;
  onOpenUser?: OpenUser;
}) => {
  if (message.failed) {
    return (
      <MessageMeta $own={own}>
        <span style={{ color: lightTheme.primary }}>
          Not sent.{' '}
          <u style={{ cursor: 'pointer' }} onClick={() => onRetry?.(message)}>
            Retry
          </u>
        </span>
      </MessageMeta>
    );
  }

  const label = senderLabel(message, viewer, fallbackSenderName);
  if (!endsRun || !label) return null;

  /*
   * Only a real sender is reachable. A `system` row has none, and on the
   * merchant side every vGrubs sender is anonymised to `id: null` - which is
   * also why the merchant app passes no handler at all: it has no screen to
   * send anyone to.
   */
  const userId = message.sender?.id ?? null;
  const openSender =
    onOpenUser && userId !== null
      ? () => onOpenUser(userId, message.sender?.role ?? null)
      : undefined;

  return (
    <MessageMeta $own={own}>
      <SenderName $clickable={!!openSender} onClick={openSender}>
        {label}
      </SenderName>
    </MessageMeta>
  );
};
